/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Icon from "../Icon";

const ClockFiveRegularV6 = (props) => (
  <Icon {...props} name="Clock Five Regular V6">
    <path d="m8.75 7.772 1.847 2.813c.256.344.163.809-.181 1.012a.724.724 0 0 1-1.041-.181l-2-3A.758.758 0 0 1 7.25 8V3.75c0-.416.334-.75.75-.75s.75.334.75.75v4.022zM16 8c0 4.419-3.581 8-8 8s-8-3.581-8-8c0-4.419 3.581-8 8-8s8 3.581 8 8zM8 1.5C4.409 1.5 1.5 4.409 1.5 8s2.909 6.5 6.5 6.5 6.5-2.909 6.5-6.5S11.591 1.5 8 1.5z" />
  </Icon>
);

export default ClockFiveRegularV6;
